import type { PValueCriteria } from './types';

export enum DifficultyLevel {
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD',
}

export const DEFAULT_CRITERIA: PValueCriteria[] = [
  {
    min: 0,
    max: 0.4,
    label: 'ยาก',
    difficultyLevel: DifficultyLevel.HARD,
  },
  {
    min: 0.41,
    max: 0.7,
    label: 'กลาง',
    difficultyLevel: DifficultyLevel.MEDIUM,
  },
  {
    min: 0.71,
    max: 1.0,
    label: 'ง่าย',
    difficultyLevel: DifficultyLevel.EASY,
  },
];

export const colorMapByDifficultyLevel: Record<DifficultyLevel, string> = {
  [DifficultyLevel.EASY]: 'success.main',
  [DifficultyLevel.MEDIUM]: 'warning.main',
  [DifficultyLevel.HARD]: 'error.main',
};
